import { toast } from 'react-toastify';
import React, { useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';

import {
  Button
} from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import { useAppContext } from '../../../../Context/App/Provider';
import { decodeHTMLEntities } from '../../../../Functions/utils';
import { reImportPiceasoftData } from '../../../../Functions/admin';

export default function ReImportPiceasoft({ groups, locations, setLocation, selectedLocationForReImportPiceasoft, setSelectedLocationForReImportPiceasoft }) {
  const { t } = useTranslation();
  const [{ user }, dispatch] = useAppContext();
  const [loading, setLoading] = useState(false);

  const [reImportDate, setReImportDate] = useState(null);
  const [reImportAll, setReImportAll] = useState(false);

  const handleReImportPiceasoft = (e) => {
    e.preventDefault();
    setLoading(true);

    const id = selectedLocationForReImportPiceasoft.id;
    const piceaApiId = selectedLocationForReImportPiceasoft.piceaApiId;
    const piceaApiKey = selectedLocationForReImportPiceasoft.piceaApiKey;

    reImportPiceasoftData({ id, piceaApiId, piceaApiKey, reImportDate, reImportAll }).then(res => {
      if (res) {
        if (!res.success) {
          setSelectedLocationForReImportPiceasoft(null);
          setLoading(false);
          return toast(decodeHTMLEntities(t('admin.locations.reimport_piceasoft.errors.' + res)), { type: 'error' });
        }
        setSelectedLocationForReImportPiceasoft(null);
        setLoading(false);
        toast(decodeHTMLEntities(t('admin.locations.reimport_piceasoft.success')), { type: 'success' });        
      }      
    });
  };

  return (
    <Prompt animated>
      <form className="prompt__container animated" onSubmit={e => {setLoading(true); handleReImportPiceasoft(e)}}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1 title={selectedLocationForReImportPiceasoft.label}>
              {decodeHTMLEntities(t('admin.locations.reimport_piceasoft.title'))}
            </h1>
            <h3>({selectedLocationForReImportPiceasoft.label})</h3>
          </div>

          <div className="prompt__content">

            <div>
              {decodeHTMLEntities(t('admin.locations.reimport_piceasoft.text_01', { name: selectedLocationForReImportPiceasoft.label }))}
            </div>

            <br />

            <div className="flexRow" style={{ alignItems: 'flex-end' }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  required={!reImportAll}
                  disabled={reImportAll}
                  disableToolbar
                  variant="inline"
                  inputVariant="outlined"
                  value={reImportDate}
                  InputAdornmentProps={{ position: 'start' }}
                  label={t('admin.locations.reimport_piceasoft.date_choice')}
                  onChange={date => setReImportDate(new Date(date).getTime() ? new Date(date.getTime() + Math.abs(date.getTimezoneOffset() * 60000)).toJSON().slice(0, 10) : null)}
                  format={localStorage.getItem('lang') === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy'}
                  placeholder={localStorage.getItem('lang') === 'fr' ? 'jj/mm/aaaa' : 'mm/dd/yyyy'}
                  style={{ width: '100%' }}
                />
              </MuiPickersUtilsProvider>
            </div>

            <div className="checkbox action">
              <input
                disabled={false}
                id="mobileProcess"
                type="checkbox"
                defaultChecked={reImportAll}
                onChange={e => setReImportAll(!reImportAll)}
              />
              <label htmlFor="mobileProcessing">{t('admin.locations.reimport_piceasoft.all_data_choice')}</label>
            </div>
          </div>
        </PromptWrapper>

        <PromptActions>
          <Button 
            className="btnSecondary"
            onClick={() => setSelectedLocationForReImportPiceasoft(null)}
          >
            {t('global.cancel')}
          </Button>

          <Button 
            className="btnPrimary" 
            type="submit" 
            disabled={loading}
          >
            {loading ?
              <BeatLoader color="white" css="transform:translateY(4px)" />
              :
              t('admin.locations.reimport_piceasoft.action')}
          </Button>
        </PromptActions>
      </form >
    </Prompt >
  );
}
